<template>
  <v-dialog v-model="dialogVisible" max-width="550" persistent>
    <v-card>
      <v-card-title>Asigneaza Profil</v-card-title>
      <v-card-text>
        <!-- Client selector -->
        <ClientSearchFilter
          v-model="selectedClientId"
          :show-include-subclients="false"
          client-select-label="Selecteaza Client *"
          @hierarchy-loaded="onHierarchyLoaded"
        />

        <v-radio-group v-model="assignType" inline density="compact" class="mb-2">
          <v-radio label="Grup IMSI" value="group" />
          <v-radio label="SIM Individual" value="sim" />
        </v-radio-group>

        <v-autocomplete
          v-if="assignType === 'group'"
          v-model="form.imsi_group_id"
          label="Selecteaza Grup IMSI *"
          :items="clientImsiGroups"
          item-title="name"
          item-value="id"
          density="compact"
          :loading="loadingGroups"
          :disabled="!selectedClientId"
          clearable
          no-data-text="Niciun grup gasit pentru acest client"
        />

        <v-autocomplete
          v-else
          v-model="form.sim_id"
          label="Selecteaza SIM *"
          :items="clientSimsList"
          item-title="label"
          item-value="id"
          density="compact"
          :loading="loadingSims"
          :disabled="!selectedClientId"
          clearable
          no-data-text="Niciun SIM gasit pentru acest client"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="close">Anuleaza</v-btn>
        <v-btn color="primary" variant="flat" @click="save" :loading="saving" :disabled="!isValid">Asigneaza</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {createProfileAssignment, getClientImsiGroups, getClientSims} from '@/composables/useTrafficAlertsAPI'
import ClientSearchFilter from '@/components/ClientSearchFilter.vue'

export default {
  name: 'ProfileAssignmentDialog',
  components: { ClientSearchFilter },
  props: {
    modelValue: Boolean,
    profileId: { type: Number, default: null }
  },
  emits: ['update:modelValue', 'saved'],
  data() {
    return {
      saving: false,
      loadingGroups: false,
      loadingSims: false,
      assignType: 'group',
      selectedClientId: null,
      clientImsiGroups: [],
      clientSims: [],
      form: { imsi_group_id: null, sim_id: null }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    },
    isValid() {
      if (!this.selectedClientId) return false
      if (this.assignType === 'group') return !!this.form.imsi_group_id
      return !!this.form.sim_id
    },
    clientSimsList() {
      return this.clientSims.map(s => ({
        id: s.id,
        label: s.msisdn ? `#${s.id} (${s.msisdn})` : `SIM #${s.id}`
      }))
    }
  },
  watch: {
    modelValue(v) {
      if (v) {
        this.form = { imsi_group_id: null, sim_id: null }
        this.assignType = 'group'
        this.selectedClientId = null
        this.clientImsiGroups = []
        this.clientSims = []
      }
    },
    selectedClientId(val, oldVal) {
      if (val && val !== oldVal) {
        this.form.imsi_group_id = null
        this.form.sim_id = null
        this.clientImsiGroups = []
        this.clientSims = []
        this.loadClientData(val)
      }
    }
  },
  methods: {
    onHierarchyLoaded({ currentClientId }) {
      if (!this.selectedClientId && currentClientId) {
        this.selectedClientId = currentClientId
      }
    },
    async loadClientData(clientId) {
      if (!clientId) return
      const token = this.$store.state.token
      this.loadingGroups = true
      this.loadingSims = true
      const [groupsResult, simsResult] = await Promise.all([
        getClientImsiGroups(token, clientId),
        getClientSims(token, clientId)
      ])
      if (!groupsResult.error) this.clientImsiGroups = groupsResult.imsi_groups || []
      if (!simsResult.error) this.clientSims = simsResult.sims || []
      this.loadingGroups = false
      this.loadingSims = false
    },
    close() {
      this.dialogVisible = false
    },
    async save() {
      this.saving = true
      const token = this.$store.state.token
      const data = {
        limitation_profile_id: this.profileId,
        ...(this.assignType === 'group' ? { imsi_group_id: this.form.imsi_group_id } : { sim_id: this.form.sim_id })
      }
      const result = await createProfileAssignment(token, data)
      this.saving = false
      if (!result.error) {
        this.$emit('saved', result.assignment)
        this.close()
      } else {
        alert(result.message)
      }
    }
  }
}
</script>
